(function($) {
    'use strict';
    
    jQuery(document).ready(function($) {
        $('#postcode-modal').on('show.bs.modal', function() {
            var $modalContent = $(this).find('.modal-content');
            var currData = $(this).data('ajax-data') || {};
            var prevData = $(this).data('prev-ajax-data') || {};
            var loadingHtml = $(this).data('loading-html') || $modalContent.html();

            // When same request as previously, don't do it twice
            if (prevData.zipCode === currData.zipCode) {
                return;
            }

            // Save for later reference
            $(this).data('prev-ajax-data', currData);
            $(this).data('loading-html', loadingHtml);

            // Loading...
            $modalContent.html(loadingHtml);

            $.ajax({
                type: 'POST',
                url: themevars.ajaxurl,
                data: {
                    zipCode: currData.zipCode,
                    action: 'coachfinder',
                    subpage: '/area/check'
                }
            })
            .done(function() {
                console.log('done', arguments);
            })
            .fail(function() {
                console.log('fail', arguments);
            })
            .always(function(response) {
                $modalContent.html(response);
            });
        });

        $(document).on('show.bs.modal hidden.bs.modal', '.modal', function(e) {
            var selector = $(e.relatedTarget).data('modal-content') || $(this).data('modal-content');
            var title = $(e.relatedTarget).data('modal-title');
            var width = $(e.relatedTarget).data('modal-width');
            var $target = $(selector);
            var $modalBody = $(this).find('.modal-body');
            var $modalTitle = $(this).find('.modal-title');

            if (! selector) {
                return;
            }

            // Save for later reference
            $(this).data('modal-content', selector);

            switch (e.type) {
                case 'show' :
                    // Inject modal contents
                    if (title) {
                        $modalTitle.text(title).show();
                    } else {
                        $modalTitle.hide();
                    }
                    if (width) {
                        $( '#modal-profile-edit .modal-dialog' ).css( 'max-width', width );
                    }
                    $target.contents().appendTo($modalBody);
                    break;
                case 'hidden' :
                    // Restore modal contents
                    $modalTitle.text('');
                    $modalBody.contents().appendTo($target);
                    break;
            }

        });
    });
})(jQuery);